import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RotatingLogo from "../../Loaders/RotatingLogo";
import { BiMoon, BiSun } from "react-icons/bi";
import { CiMonitor } from "react-icons/ci";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import { useLanguage } from "../../Translations/LenguageContext";

const ExperienceStep = ({
    handleStep,
    soundClick,
    error,
    loadingSteps
}) => {
    const { t } = useLanguage()
    const [appearance, setAppearance] = useState(() => {
        return localStorage.getItem("absttheme-preference") || "system";
    });

    const clickAction = (theme) => {
        soundClick()
        setAppearance(theme)
    }

    useEffect(() => {
        const root = window.document.documentElement;
        const applyTheme = (theme) => {
            let themeToSet = theme;
            if (theme === "system") {
                themeToSet = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
            }
            root.setAttribute("data-theme", themeToSet);
            localStorage.setItem("absttheme-preference", theme);
            window.dispatchEvent(new Event("absttheme-changed"));
        };
        applyTheme(appearance);
    }, [appearance]);

    return (
        <div className="steps_main_container">
            <div className="welcome_step_cont">
                <div className="welcome_step_cont_inner">
                    <p className="step_title fade-in">{t.onboarding.experience.title}</p>
                    <p className="step_description fade-in">{t.onboarding.experience.subtitle}</p>
                    <div className="experience_cont">
                        <button className={`experience_cont_choise fade-in ${appearance == "light" && "experience_cont_choise_selected"}`} onClick={() => clickAction("light")}>
                            <span><BiSun /> {t.onboarding.experience.light}</span>
                        </button>
                        <button className={`experience_cont_choise fade-in ${appearance == "dark" && "experience_cont_choise_selected"}`} onClick={() => clickAction("dark")}>
                            <span><BiMoon /> {t.onboarding.experience.dark}</span>
                        </button>
                        <button className={`experience_cont_choise fade-in ${appearance == "system" && "experience_cont_choise_selected"}`} onClick={() => clickAction("system")}>
                            <span><CiMonitor /> {t.onboarding.experience.system}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="steps_btn_cont">
                <button className="steps_btn fade-in" onClick={() => handleStep("back", "language")}>
                    <i className="fa-solid fa-chevron-left"></i> {t.onboarding.back}
                </button>
                <div>
                    <ErrorMessage err={error} />
                </div>
                <button className="steps_btn fade-in" onClick={() => handleStep("continue", "info")}>
                    {loadingSteps ? (
                        <Spinner loading={true} />
                    ) : (
                        <>{t.onboarding.continue} <i className="fa-solid fa-chevron-right"></i></>
                    )}
                </button>
            </div>
        </div>
    )
}

export default ExperienceStep